module.exports = __webpack_public_path__ + "img/Med06_GR01-20070073-001.38915f23.jpg";